import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [{
  name: 'menu.welcome',
  key: 'welcome',
  breadcrumb: false
}, {
  name: 'menu.creative',
  key: 'creative',
  children: [{
    name: 'menu.creative.editing-script',
    key: 'creative/editing-script/list'
  }, {
    name: 'menu.creative.editing-script.add',
    key: 'creative/editing-script/add',
    ignore: true
  } // {
  //   name: "menu.creative.ai-image",
  //   key: "creative/ai-image/list",
  // },
  // {
  //   name: "menu.creative.ai-model",
  //   key: "creative/ai-model/list",
  // },
  // {
  //   name: "menu.creative.ai-model.add",
  //   key: "creative/ai-model/add",
  //   ignore: true,
  // },
  // {
  //   name: "menu.creative.ai-crossdress",
  //   key: "creative/ai-crossdress/list",
  // },
  // {
  //   name: "menu.creative.ai-crossdress.add",
  //   key: "creative/ai-crossdress/add",
  //   ignore: true,
  // },
  // {
  //   name: "menu.creative.ai-video",
  //   key: "creative/ai-video/list",
  // },
  // {
  //   name: "menu.creative.ai-video.add",
  //   key: "creative/ai-video/add",
  //   ignore: true,
  // },
  // {
  //   name: "menu.creative.ai-audio",
  //   key: "creative/ai-audio/list",
  // },
  // {
  //   name: "menu.creative.ai-tts",
  //   key: "creative/ai-tts/list",
  // },
  // {
  //   name: "menu.creative.ai-human",
  //   key: "creative/ai-human/list",
  // }
  ]
}, {
  name: 'menu.customer',
  key: 'customer',
  children: [{
    name: 'menu.customer.brand.add',
    key: 'customer/brand/add',
    ignore: true
  }, {
    name: 'menu.customer.brand.list',
    key: 'customer/brand/list'
  }, {
    name: 'menu.customer.brand.result',
    key: 'customer/brand/result',
    ignore: true
  }, {
    name: 'menu.customer.store.list',
    key: 'customer/store/list'
  }, {
    name: 'menu.customer.store.add',
    key: 'customer/store/add',
    ignore: true
  }, {
    name: 'menu.customer.store.result',
    key: 'customer/store/result',
    ignore: true
  }, {
    name: 'menu.customer.store.data-analysis',
    key: 'customer/store/data-analysis',
    ignore: true
  }]
}, {
  name: 'menu.cards',
  key: 'cards',
  children: [{
    name: 'menu.cards.add',
    key: 'cards/add',
    ignore: true
  }, {
    name: 'menu.cards.list',
    key: 'cards/list'
  }, {
    name: 'menu.cards.result',
    key: 'cards/result',
    ignore: true
  }]
}, {
  name: 'menu.material',
  key: 'material',
  children: [// {
  //   name: 'menu.material.add',
  //   key: 'material/add',
  //   children: [
  //     // {
  //     //   name: 'menu.material.text.add',
  //     //   key: 'material/add/text',
  //     // },
  //     // {
  //     //   name: 'menu.material.audio.add',
  //     //   key: 'material/add/audio',
  //     // },
  //     // {
  //     //   name: 'menu.material.add.video',
  //     //   key: 'material/add/video',
  //     //   ignore: true,
  //     // },
  //     // {
  //     //   name: 'menu.material.add.image',
  //     //   key: 'material/add/image',
  //     // },
  //     {
  //       name: 'menu.material.add.result',
  //       key: 'material/add/result',
  //       ignore: true,
  //     },
  //   ],
  // },
  {
    name: 'menu.material.video.list',
    key: 'material/video/list'
  }, // {
  //   name: 'menu.material.add',
  //   key: 'material/add',
  //   ignore: true,
  // },
  {
    name: 'menu.material.add.video',
    key: 'material/add/video',
    ignore: true
  }, {
    name: 'menu.material.add.result',
    key: 'material/add/result',
    ignore: true
  }, {
    name: 'menu.material.note.list',
    key: 'material/note/list'
  }]
}, {
  name: 'menu.video-cut',
  key: 'video-cut',
  children: [// {
  //   name: 'menu.video-cut.material',
  //   key: 'video-cut/material',
  //   children: [
  //     {
  //       name: 'menu.video-cut.material.video',
  //       key: 'video-cut/material/video/list',
  //     },
  //     {
  //       name: 'menu.video-cut.material.video.add',
  //       key: 'video-cut/material/video/add',
  //       ignore: true,
  //     },
  //     {
  //       name: 'menu.video-cut.material.video.detail',
  //       key: 'video-cut/material/video/detail',
  //       ignore: true,
  //     },
  //     {
  //       name: 'menu.video-cut.material.image',
  //       key: 'video-cut/material/image',
  //     },
  //     {
  //       name: 'menu.video-cut.material.audio',
  //       key: 'video-cut/material/audio/list',
  //     },
  //     {
  //       name: 'menu.video-cut.material.audio.add',
  //       key: 'video-cut/material/audio/add',
  //       ignore: true,
  //     },
  //   ]
  // },
  {
    name: 'menu.video-cut.material.video',
    key: 'video-cut/material/video/list'
  }, {
    name: 'menu.video-cut.material.video.add',
    key: 'video-cut/material/video/add',
    ignore: true
  }, {
    name: 'menu.video-cut.material.video.detail',
    key: 'video-cut/material/video/detail',
    ignore: true
  }, {
    name: 'menu.video-cut.material.image',
    key: 'video-cut/material/image/list'
  }, {
    name: 'menu.video-cut.material.image.detail',
    key: 'video-cut/material/image/detail',
    ignore: true
  }, {
    name: 'menu.video-cut.material.audio',
    key: 'video-cut/material/audio/list'
  }, {
    name: 'menu.video-cut.material.audio.add',
    key: 'video-cut/material/audio/add',
    ignore: true
  }, // {
  //   name: 'menu.video-cut.template',
  //   key: 'video-cut/template',
  //   children: [
  //     {
  //       name: 'menu.video-cut.template.list',
  //       key: 'video-cut/template/list',
  //     }
  //   ]
  // },
  {
    name: 'menu.video-cut.cut',
    key: 'video-cut/cut',
    children: [{
      name: 'menu.video-cut.cut.add',
      key: 'video-cut/cut/add-batch'
    }, {
      name: 'menu.video-cut.cut.ai',
      key: 'video-cut/cut/add-batch-ai'
    }, {
      name: 'menu.video-cut.cut.list',
      key: 'video-cut/cut/list'
    }, {
      name: 'menu.video-cut.cut.detail',
      key: 'video-cut/cut/detail',
      ignore: true
    }, {
      name: 'menu.video-cut.cut.audit',
      key: 'video-cut/cut/audit'
    }]
  }, {
    name: 'menu.video-cut.note',
    key: 'video-cut/note',
    children: [{
      name: 'menu.video-cut.note.add',
      key: 'video-cut/note/add'
    }]
  }, // {
  //   name: 'menu.video-cut.template-cut',
  //   key: 'video-cut/template-cut',
  //   children: [
  //       {
  //         name: 'menu.video-cut.template-cut.add',
  //         key: 'video-cut/template-cut/add',
  //       },
  //       {
  //         name: 'menu.video-cut.template-cut.list',
  //         key: 'video-cut/template-cut/list',
  //       },
  //       {
  //         name: 'menu.video-cut.template-cut.detail',
  //         key: 'video-cut/template-cut/detail',
  //         ignore: true,
  //       },
  //       {
  //         name: 'menu.video-cut.template-cut.audit',
  //         key: 'video-cut/template-cut/audit',
  //       },
  //   ]
  // },
  {
    name: 'menu.video-cut.result',
    key: 'video-cut/result',
    ignore: true
  }]
}, {
  name: 'menu.weixin',
  key: 'weixin',
  children: [{
    name: 'menu.weixin.bind.list',
    key: 'weixin/bind/list'
  }]
}, {
  name: 'menu.user',
  key: 'user',
  children: [// {
  //   name: 'menu.user.info',
  //   key: 'user/info',
  // },
  {
    name: 'menu.user.setting',
    key: 'user/setting'
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;

    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};

const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }

    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;

      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }

      if (!visible) {
        continue;
      }

      if (route.children && route.children.length) {
        const newRoute = { ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);

        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route
        });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];

    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }

    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};

export default useRoute;